import { Dispatch, ThunkAction } from 'app/types/actions';
import { IGetState } from '../../../../../../types/types';
import { segmentTrackAction, SegmentUserEvent } from '../../../../../../middlewares/segment';
import { initWebPushNotifications } from '../../../../../../helper/webPushNotify';
import { hintHide } from '../../../../hints/effects/hintHide';
import { EHintKey } from '../../../../hints';

export function onAllow (
): ThunkAction {
    const action = (
        dispatch: Dispatch,
        getState: IGetState,
    ) => {
        dispatch(segmentTrackAction(SegmentUserEvent.BROWSER_NOTIFICATIONS_ALLOW_CLICKED));
        initWebPushNotifications(() => {
            return new Promise((resolve, reject) => {
                resolve(true)
            })
        });
        dispatch(hintHide(EHintKey.PUSH_NOTIFICATIONS));
    };
    return action
};
